import { CompanyDocumentTreeNode } from "../model/types";

/**
 * Родители узла от верхнего уровня до непосредственного. Уже пройденный узел
 * обрывает подъём: цикл в `parentId` (гонка двух переносов) не повесит вкладку.
 */
export function ancestorsOf(
  node: CompanyDocumentTreeNode,
  nodeById: Map<string, CompanyDocumentTreeNode>,
): CompanyDocumentTreeNode[] {
  const ancestors: CompanyDocumentTreeNode[] = [];
  const visited = new Set([node.id]);

  for (
    let parent = node.parentId ? nodeById.get(node.parentId) : undefined;
    parent && !visited.has(parent.id);
    parent = parent.parentId ? nodeById.get(parent.parentId) : undefined
  ) {
    visited.add(parent.id);
    ancestors.unshift(parent);
  }

  return ancestors;
}
